import React from 'react';
import classnames from 'classnames';
import { BiLoggerContextProvider } from '../../biLogger/BiLogger.context';
import UserAvatar from '../../User/Avatar';
import Stats from '../_partials/Stats';
import DeviationFlags from '../../ActionBar/buttons/DeviationFlags';
import DateAndMatureIndicator from '../_partials/DateAndMatureIndicator';
import Author from '../_partials/Author';
import Title from '../_partials/Title';
import { useFlag } from '../../redux/flags/hooks/useFlag';
import s from './MobileSubmissionDetails.scss';
var MobileSubmissionDetails = function (_a) {
    var className = _a.className, deviation = _a.deviation, _b = _a.deviation, author = _b.author, title = _b.title, dailyDeviation = _b.dailyDeviation, isOwner = _a.isOwner, showTitle = _a.showTitle;
    var isUplifted = useFlag('mobile_duper_header');
    return (React.createElement("div", { className: classnames(s['root'], className, isUplifted && s['uplifted'], dailyDeviation && s['with-flag']) },
        dailyDeviation && (React.createElement("div", { className: s['flag'] },
            React.createElement(DeviationFlags, { deviation: deviation }))),
        React.createElement(Title, { title: title, showTitle: showTitle, className: s['title'] }),
        isUplifted && (React.createElement(DateAndMatureIndicator, { publishedTime: deviation.publishedTime, isMature: deviation.isMature, className: s['date'] })),
        !isUplifted && (React.createElement("div", { className: s['left'] },
            React.createElement(BiLoggerContextProvider, { value: { sectionname: 'author' } },
                author && (React.createElement(UserAvatar, { withTooltip: true, size: 32, user: author, className: s['avatar'] })),
                React.createElement("div", { className: s['author-block'] },
                    React.createElement(Author, { author: author, isOwner: isOwner, className: s['author'] }),
                    React.createElement(DateAndMatureIndicator, { publishedTime: deviation.publishedTime, isMature: deviation.isMature, className: s['date'] }))))),
        !isUplifted && React.createElement(Stats, { deviation: deviation })));
};
MobileSubmissionDetails.displayName = 'MobileSubmissionDetails';
export default MobileSubmissionDetails;
//# sourceMappingURL=MobileSubmissionDetails.js.map